import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiKeyService } from 'src/app/service/api-key.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [MessageService]
})
export class SettingsComponent {
  tableHeaders: string[] = ['Name', 'IP Addresses', 'Expires In'];
  tableData: any[] = [];
  apiKeys: any = {};
  modalTitle: string = '';
  isModalOpen: boolean = false;
  errorMessage: string = '';
  generatedApiKey: string = '';
  apiKeyCreated: boolean = false;
  isLoading: boolean = false;
  fetchingData: boolean = false;
  processLoading: boolean = false;
  apiKeyId: string = '';
  isModalOpen2: boolean = false
  modalTitle2: string = 'Delete this Api Key?  ';
  id: string | number = '';

  constructor(private apiKeyService: ApiKeyService, private router: Router, private messageService: MessageService) {}

  ngOnInit() {
    this.getApiKeys();
  }

  ngOnChanges() {
    this.errorMessage = "";
    this.apiKeyCreated = false;
    this.generatedApiKey = "";
  }

  addApiKey = () => {
    this.modalTitle = 'Add API Key';
    this.isModalOpen = true;
  };
  closeModal = () => {
    this.isModalOpen = false;
  };
  closeModal2 = () => {
    this.isModalOpen2 = false;
  };
  showModal = (id: string | number) => {
    this.isModalOpen2 = true;
     this.id = id;
  }


  deleteApi = () => {
    this.processLoading = true;
    this.apiKeyId = this.id.toString()
    const apikey = {"apiKeyId": this.apiKeyId}
    // console.log(this.apiKeyId)
    this.apiKeyService.deleteApiKey(apikey).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.getApiKeys()
        this.isLoading = true;
        // console.log('Api Key deleted successfully');
        this.messageService.add({ severity: 'success', summary: 'Successfully Deleted', detail: 'API Key Successfully Deleted' });
        this.apiKeyCreated = true;
        this.processLoading = false;
        this.isModalOpen2 = false;
        setTimeout(() => {}, 2000);
      } else {
        this.isLoading = false
        // console.log('Problem creating Api Key');
      }
    });
  }

  newApiKey = {
    name: '',
    ipAddresses: [] as string[],
    expiresIn: '',
  };

  durationOptions = [
    { value: '1day', label: 'One Day' },
    { value: '1week', label: 'One Week' },
    { value: '1month', label: 'One Month' },
    { value: '3months', label: 'Three Months' },
    { value: '6months', label: 'Six Months' },
    { value: '1year', label: 'One Year' },
  ];

  onSelectedDuration(selectedValue: string) {
    this.newApiKey.expiresIn = selectedValue;
    // console.log('Selected Dropdown Value:', selectedValue);
  }
  newName(data: string) {
    this.newApiKey.name = data;
  }
  

  newIpAddress(data: string) {
    this.newApiKey.ipAddresses = data.split(',');
      this.newApiKey.ipAddresses = this.newApiKey.ipAddresses.map((ip: string) => {
        return ip.trim();
      })
  }

  createApiKey = () => {
    this.isLoading = true;
    this.apiKeyService.createApiKey(this.newApiKey).subscribe((res: any) => {
      if (res.statusCode === 200) {
        // console.log('Api Key Created successfully');
        this.messageService.add({ severity: 'success', summary: 'Successfully Created', detail: 'API Key Successfully Created' });
        this.generatedApiKey = res.data.apiKey;
        this.isLoading = false;
        this.apiKeyCreated = true;
        this.getApiKeys();
        setTimeout(() => {}, 2000);
      } else {
        this.isLoading = false
        // console.log('Problem creating Api Key');
      }
    });
  };

  
  async getApiKeys() {
    this.fetchingData = true;
    this.apiKeyService.getApiKeys().subscribe({
      next: (res: any) => {
        this.apiKeys = res.data;
        this.fetchingData = false;
        // console.log(this.apiKeys);
        if (this.apiKeys.length > 0) {
          for (let i = 0; i < this.apiKeys.length; i++) {
            // console.log(this.apiKeys[i]);
          }
          this.tableData = this.apiKeys?.map((i: any, n: number) => {
            return [i._id, i.name, i.ipAddresses, i.duration];
          });
          this.fetchingData = false;
        }
        error: (error: any) => {
          // this.fetchingData = false;
        };
      },
    });
  }
  del=()=>{

  }
}
